const headerLinks = [
    {
      title: "Finance",
      link: "/category/finance",
      isDropdown: true,
      option: [
        {
          title: "Transition Finance",
          link: "/category/transition-finance",
        },
        {
          title: "Investments",
          link: "/category/investments",
        },
      ]
    },
    {
      title: "Clean Energy",
      link: "/category/clean-energy",
    },
    {
      title: "Policy & Regulation",
      link: "/category/policy-regulation",
    },
    {
      title: "Carbon Markets",
      link: "/category/carbon-markets",
    },
    {
      title: "High Emitting Industries",
      link: "/",
      isDropdown: true,
      option: [
        {
          title: "Coal",
          link: "/category/coal",
        },
        {
          title: "Oil & Gas",
          link: "/category/oil-and-gas",
        },
        {
          title: "Real - Estate",
          link: "/category/real-estate",
        },
        {
          title: "Steel",
          link: "/category/steel",
        },
        {
          title: "Transport",
          link: "/category/transport",
        },
      ],
    },
];

export default headerLinks;